module.exports = require('./lib/axios');